export default "__VITE_ASSET__CKnBLRFQ__"